// @flow
import {Store} from 'Store'
import * as Sentry from '@sentry/browser'

export class Api {
  root: Store
  constructor(rootStore: any) {
    this.root = rootStore
  }

  get headers(): Headers {
    const token = localStorage.getItem('accessToken')
    let headers = new Headers()
    headers.set('Accept', 'application/json')
    headers.set('Content-Type', 'application/json')
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    return headers
  }

  async request(url: string, method: string, body?: {[key: string]: any}): Promise<{[key: string]: any}> {
    try {
      await this.root.auth.refreshToken()
      return this.req(url, method, body)
    } catch(e) {
      throw e
    }
  }

  async req(url: string, method: string, body?: {[key: string]: any}) {
    let options = {
      headers: this.headers,
      method: method.toUpperCase()
    }
    if (body) {
      options = {body: JSON.stringify(body), ...options}
    }
    const response = await fetch(`api/v1/${url}`, options)
    if (response.ok) {
      try {
        return await response.json()
      } catch (e) {
        if (process.env.SENTRY) {
          Sentry.withScope(scope => {
            for (let key in e) {
              scope.setExtra(key, e[key])
            }
          })
          Sentry.captureException(e)
        }
        return response
      }
    } else {
      if (response.status === 400 && url === 'user' && method === 'patch') {
        return await response.json()
      }
      if (response.status === 401) {
        this.root.auth.logout()
      }
      const error = await response.json()
      if (error.code === 4453) {
        this.root.ib.openModal()
      }
      if (process.env.SENTRY && error.code !== 4022) {
        Sentry.captureException(new Error(error.message))
      }
      throw error
    }
  }
}
